import React, { useEffect, useState } from "react";
import { Add } from "@mui/icons-material";
import { tableUseStyle } from "../../etc/tableusestyle";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import { Button } from "@mui/joy";
import { getFetch, postFetch } from "../../../../../fetch/fetch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import WiredPhoneSettingModal from "./wiredphonesettingmodal";

const toastOptions : any = {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: true,
    theme: "colored"
};

//본사직원페이지 > 유선 전화기 등록: 선생님별 웹 발신(전화걸기) 기본값(상담사 내선·발신번호) 표 + 설정 모달
const WiredPhoneSetting : React.FC<any> = (props) => {

    const classes = tableUseStyle();

    const [rows, setRows] = useState<any[]>([]);
    const [teachers, setTeachers] = useState<any[]>([]);
    const [agents, setAgents] = useState<any[]>([]);
    const [branches, setBranches] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);

    const columns : any[] = [
        { field: "teacherName", headerName: "선생님", width: 160 },
        {
            field: "agentExtension",
            headerName: "상담사 번호",
            width: 200,
            valueGetter: (params : any) => `${params.row.agentName} (${params.row.agentExtension})`
        },
        {
            field: "branchQueue",
            headerName: "발신번호",
            width: 220,
            valueGetter: (params : any) => params.row.branchQueue ? `${params.row.branchName} (${params.row.displayNumber})` : "-"
        },
        { field: "createdBy", headerName: "등록자", width: 120 },
        { field: "createdAt", headerName: "등록일시", width: 160 },
        {
            field: "delete",
            headerName: "삭제",
            width: 100,
            sortable: false,
            filterable: false,
            renderCell: (params : any) => (
                <Button
                    size="sm"
                    variant="outlined"
                    color="danger"
                    onClick={() => handleDelete(params.row)}
                >
                    삭제
                </Button>
            )
        }
    ];

    const fetchList = async () => {
        try {
            setLoading(true);
            const result : any = await getFetch("/dashboard/callcenter/outcall/defaults");
            if (result.message === "success") {
                setRows(result.rows || []);
                setTeachers(result.teachers || []);
                setAgents(result.agents || []);
                setBranches(result.branches || []);
            } else {
                console.log(result);
                toast.error(result.message === "CALLCENTER_DISABLED" ? "콜센터 모듈이 꺼져 있습니다" : "목록을 불러오지 못했습니다", toastOptions);
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchList();
    }, []);

    const handleDelete = async (row : any) => {
        if (!window.confirm(`${row.teacherName} 선생님의 유선폰 설정을 삭제할까요?`)) return;
        try {
            const result : any = await postFetch("/dashboard/callcenter/outcall/defaults/delete", { id: row.id });
            if (result.message === "success") {
                toast.success("삭제되었습니다", toastOptions);
                fetchList();
            } else {
                toast.error(result.message === "NOT_AUTHORIZED" ? "권한이 없습니다" : "삭제 실패: " + result.message, toastOptions);
            }
        } catch (e) {
            console.log(e);
            toast.error("오류가 발생했습니다", toastOptions);
        }
    };

    return (
        <div style={{ width: "96%" }}>
            <div style={{
                fontFamily: "Apple_B",
                marginTop: "50px",
                fontSize: "18px",
                display: "flex",
                alignItems: "center",
            }}>
                <div style={{ marginRight: "18px" }}>
                    유선 전화기 등록 내역
                </div>
                <div>
                    <Button variant="solid" startDecorator={<Add />} size="sm" onClick={() => setOpen(true)}>
                        유선폰 설정하기
                    </Button>
                </div>
            </div>
            <div style={{ fontSize: "13px", color: "#777", marginTop: "8px", marginBottom: "16px" }}>
                선생님별로 전화걸기 패널의 기본 상담사 번호(필수)와 발신번호(선택)를 정합니다. 한 선생님당 1건, 변경은 삭제 후 재등록.
            </div>

            <div className={classes.root} style={{ height: "500px", width: "100%" }}>
                <DataGridPremium
                    rows={rows}
                    columns={columns}
                    density="compact"
                    loading={loading}
                    disableRowSelectionOnClick
                />
            </div>

            <WiredPhoneSettingModal
                open={open}
                onClose={() => setOpen(false)}
                onAdded={fetchList}
                teachers={teachers}
                agents={agents}
                branches={branches}
            />
        </div>
    );
};

export default WiredPhoneSetting;
